import { fromJS } from 'immutable';

import {
  MODAL_SET,
  MODAL_CLEAR,
  MODAL_LOADING,
  MODAL_ERROR,
} from '../constants/modal';

const initialState = fromJS({
  showModal: null,
  loading: false,
  error: null,
});

function modalReducer(state = initialState, action) {
  switch (action.type) {
  case MODAL_SET:
    return state
      .set('loading', false)
      .set('showModal', action.modalName);
  case MODAL_LOADING:
    return state
      .set('loading', action.loading)
      .set('error', null);
  case MODAL_CLEAR:
    return state
      .set('showModal', null)
      .set('loading', false)
      .set('error', null);
  case MODAL_ERROR:
    return state
      .set('error', action.error)
      .set('loading', false);
  default:
    return state;
  }
}

export default modalReducer;



/** WEBPACK FOOTER **
 ** ./src/reducers/modal.js
 **/